import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';
import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.kiera.management.settings');
import { OnInit } from '@angular/core';
import { Service } from 'src/libs/portal/season/service';


@Component({
 standalone: false,
 selector: 'wiz-page-kiera-management-settings',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/.kiera-build/src/app/page.kiera.management.settings/view.scss */
:host {
  display: block;
  min-height: 100%;
}`],
})
export class PageKieraManagementSettingsComponent implements OnInit {
    public loading: boolean = true;
    public saving: boolean = false;
    public running: boolean = false;
    public errorMessage: string = '';
    public noticeMessage: string = '';
    public settings: any = {};
    public counts: any = {};
    public activeWindows: any[] = [];
    public latestCollectionAt: string = '';
    public activeWindowCount: number = 0;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    private applySummary(data: any) {
        this.settings = { ...(data?.settings || {}) };
        this.counts = data?.counts || {};
        this.activeWindows = Array.isArray(data?.active_windows) ? data.active_windows : [];
        this.latestCollectionAt = String(data?.latest_collection_at || '');
        this.activeWindowCount = Number(data?.active_window_count || 0);
    }

    public async load() {
        this.loading = true;
        this.errorMessage = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('load');
            if (code !== 200) {
                this.errorMessage = data?.message || '관리 설정을 불러오지 못했습니다.';
            } else {
                this.applySummary(data);
            }
        } catch (error) {
            this.errorMessage = String(error || '관리 설정을 불러오지 못했습니다.');
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public async save() {
        if (this.saving) return;
        this.saving = true;
        this.errorMessage = '';
        this.noticeMessage = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('save', {
                data: JSON.stringify(this.settings),
            });
            if (code !== 200) {
                this.errorMessage = data?.message || '관리 설정을 저장하지 못했습니다.';
            } else {
                this.applySummary(data?.summary);
                this.noticeMessage = 'BMC 자동 점검 설정을 저장했습니다.';
            }
        } catch (error) {
            this.errorMessage = String(error || '관리 설정을 저장하지 못했습니다.');
        } finally {
            this.saving = false;
            await this.service.render();
        }
    }

    public async runNow() {
        if (this.running || this.activeWindowCount > 0) return;
        this.running = true;
        this.errorMessage = '';
        this.noticeMessage = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('run_now');
            if (code !== 200) {
                this.errorMessage = data?.message || 'BMC 점검을 예약하지 못했습니다.';
            } else {
                this.applySummary(data?.summary);
                const scheduled = data?.scheduled || {};
                this.noticeMessage = scheduled.ran
                    ? `${scheduled.node_count || 0}개 노드를 슬라이딩 윈도우 작업 큐에 등록했습니다.`
                    : `점검을 시작하지 않았습니다: ${scheduled.reason || '대기 중'}`;
            }
        } catch (error) {
            this.errorMessage = String(error || 'BMC 점검을 예약하지 못했습니다.');
        } finally {
            this.running = false;
            await this.service.render();
        }
    }

    public formatDate(value: any): string {
        if (!value) return '-';
        const date = new Date(String(value).replace(' ', 'T'));
        if (Number.isNaN(date.getTime())) return String(value);
        return date.toLocaleString();
    }

    public taskNodeCount(task: any): number {
        return Array.isArray(task?.payload?.node_ids) ? task.payload.node_ids.length : 0;
    }
}

export default PageKieraManagementSettingsComponent;
